<template>
<div class="nkn-home-swiper">
    <a>
        <div class="container swiper-besides-image-container">
            <div class="container clearfix">
                    <img v-if="lang === 'zh'" v-lazy="'/static/img/home/swiper/Narwhal-01.png'">
                    <img v-else v-lazy="'/static/img/home/swiper/Narwhal-02.png'">
            </div>
        </div>
    </a>
    <!--<swiper :options="swiperOption" class="swiper-container">
    <swiper-slide class="common-swiper common-swiper-progress">
      <a :href="'zh' === lang ? 'https://mp.weixin.qq.com/s/2OF_fF2YTRHAD3c-Lik3fA':'https://medium.com/nknetwork/nkn-releases-mainnet-v0-9-beluga-7ec8fdf4caf4?source=collection_home-&#45;&#45;4&#45;&#45;&#45;&#45;&#45;&#45;0-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;'"
         target="_blank">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <div class="swiper-text-title">{{$t("home.swiper.title2")}}</div>
                <div class="swiper-text-content">{{$t("home.swiper.content2")}}</div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/BelugaNew.png">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <swiper-slide class="common-swiper common-swiper-upbit">
      <a :href="$url.SWIPER.upbit" target="_blank" >
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <div class="swiper-text-title">{{$t("home.swiper.title4")}}</div>
                <div class="swiper-text-content" v-html="$t('home.swiper.content4sub1')"></div>
                <div class="swiper-text-content" v-html="$t('home.swiper.content4sub2')"></div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/NKN-Upbit.png">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <swiper-slide class="common-swiper common-swiper-web3">
      <a :href="$url.SWIPER.web3" target="_blank" >
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <div class="swiper-text-title">{{$t("home.swiper.title5")}}</div>
                <div class="swiper-text-content" v-html="$t('home.swiper.content5')"></div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/NKN-W3i.png">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <swiper-slide class="common-swiper common-swiper-report">
      <a :href="$url.SWIPER.bittrex" target="_blank" >
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <div class="swiper-text-title">{{$t("home.swiper.title1")}}</div>
                <div class="swiper-text-content" v-html="$t('home.swiper.content1sub1')"></div>
                <div class="swiper-text-content" v-html="$t('home.swiper.content1sub2')"></div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/NKN-Bittrex.png">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <swiper-slide class="common-swiper common-swiper-binance">
      <a :href="'zh' === lang ? 'https://swap.nkn.org/announcement/zh':'https://swap.nkn.org/announcement/en'" target="_blank">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <p class="swiper-text-title">{{$t("home.swiper.title3")}}
                  {{$t("home.swiper.title3sub")}}</p>
                <div class="swiper-text-content">
                  <div class="li-content">{{$t("home.swiper.content3sub1")}}</div>
                  <div class="li-content">{{$t("home.swiper.content3sub2")}}</div>
                  <div class="li-content">{{$t("home.swiper.content3sub3")}}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/Tokenswap.png" class="pic-swiper-Tokenswap">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <swiper-slide class="common-swiper common-swiper-report">
      <a :href="$url.SWIPER.update" target="_blank" >
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-text">
                <div class="swiper-text-title">{{$t("home.swiper.title1")}}</div>
                <div class="swiper-text-content">{{$t("home.swiper.content1")}}</div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6">
              <div class="swiper-pic">
                <img src="/static/img/home/swiper/November.png" class="pic-swiper-November">
              </div>
            </div>
          </div>
        </div>
      </a>
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>-->

</div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import {
  mapGetters
} from 'vuex'
export default {
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapGetters({
      lang: 'getLang'
    })
  },
  data: function () {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: false,
        // 自动播放
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nkn-home-swiper {
  .swiper-container {
    width: 100%;

    @media screen and (max-width: 768px) {
      height: 320px;
    }
  }

  .swiper-besides-image-container {
      text-align: center;
      padding: 0;
      margin: 0;
      width: 100%;
      background: #08074f;
      .narwhal-released-spacer {

      }
      img {
          width: 100%;
          height: 100%;
      }

  }

  .common-swiper {
    overflow: hidden;
    box-sizing: border-box;
    text-align: center;
    min-height: 300px;

    .swiper-text {
      color: white;
      margin-top: 80px;
      margin-left: 90px;
      @media screen and (max-width: 768px) {
        /*height: 400px;*/
        margin: 20px auto;
      }

      &-title {
        text-align: left;
        @include nkn-font-set(2rem, currentColor);
        line-height: 24px;
        font-size: 24px;
        margin-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: 18px;
          line-height: 18px;
        }
      }

      &-content {
        text-align: justify;
        width: 25rem;
        @include nkn-font-set(1.2rem, currentColor);
        line-height: 20px;
        font-size: 18px;
        font-weight: 300;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 14px;
        }
      }
    }

    .swiper-pic {
      text-align: center;
      img {
        width: 300px;
        height: auto;
        @media screen and (max-width: 768px) {
          width: 200px;
        }
      }
    }

    &-upbit {
      background: #336fd6;
    }

    &-web3 {
      background: #efefef;
      .swiper-text {
        color: #253a7e;
      }
    }

    &-report {
      background: #1a5494;
    }

    &-progress {
      background: #313f7f;
    }

    &-binance {
      background: #4655a8;

      img {
        width: 300px;
        height: auto;
        @media screen and (max-width: 768px) {
          margin-top: -20px;
          width: 160px !important;
        }
      }
      .swiper-text {
        margin-top: 60px;
        @media screen and (max-width: 768px) {
          margin: 20px auto;
        }
        &-title {
          line-height: 24px;
          font-size: 24px;
          margin-bottom: 10px;
          white-space: nowrap;
        }

        &-title {
          @media screen and (max-width: 768px) {
            font-size: 18px;
            line-height: 18px;
          }
        }

        &-content {
          @include nkn-font-set(.9rem, currentColor);
          line-height: 22px;
          font-size: 18px;
          font-weight: 300;
          @media screen and (max-width: 768px) {
            font-size: 14px;
            line-height: 14px;
          }

          .li-content {
            position: relative;
            padding-left: 1rem;
            margin-bottom: 8px;

            &::before {
              content: '';
              width: .4rem;
              height: .4rem;
              background: #fff;
              border-radius: 50%;
              position: absolute;
              left: 0;
              top: 8px;
            }
          }
        }
      }

    }
  }
}

.common-swiper.common-swiper-upbit .swiper-pic {
  img {
    width: 260px;
    height: auto;
    margin-top: 40px;
    @media screen and (max-width: 768px) {
      width: 160px;
      margin-top: 10px;
    }
  }
}

.common-swiper.common-swiper-web3 .swiper-pic {
  img {
    width: 300px;
    height: auto;
    margin-top: 40px;
    @media screen and (max-width: 768px) {
      width: 160px;
      margin-top: 10px;
    }
  }
}

.common-swiper.common-swiper-report .swiper-pic {
  img {
    width: 300px;
    height: auto;
    margin-top: 60px;
    @media screen and (max-width: 768px) {
      width: 200px;
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknHomeSwiper.vue